let eventList = []

let holdKey = []
let groupSortField = []
let sortType = []
let getHoldKeyInstance = {
  get: () => holdKey,
  set: (hkey) => {
    holdKey = hkey
  },
  isHoldKeyCode: (keyCode) => {
    // 确保只按下了一个比如ctrl
    return holdKey.length === 1 && holdKey.indexOf(keyCode) === 0
  },
  getGroupSortField: () => {
    return groupSortField
  },
  setGroupSortField: (v) => {
    groupSortField = v
  },
  addGroupSortField: (v) => {
    groupSortField.push(v)
  },
  addSortType: (v) => {
    sortType.push(v)
  },
  getSortType: () => {
    return sortType
  },
  setSortType: (v) => {
    sortType = v
  },
  setSortTypeByIndex: (index, v) => {
    sortType[index] = v
  }
}
let addKeyHoldListener = (el) => {
  if (eventList.length === 0) {
    eventList.push('inited')
    document.addEventListener('keydown', function (event) {
      let index = holdKey.indexOf(event.keyCode)
      if (index < 0) {
        holdKey.push(event.keyCode)
      }
    }, false)
    document.addEventListener('keyup', function (event) {
      holdKey = []
    }, false)
  }
  return getHoldKeyInstance
}
export default {
  addKeyHoldListener
}



// WEBPACK FOOTER //
// ./src/util/eventlistener.js